import { QrPaymentView } from '../../../checkout/QrPaymentView.js';
import type { CheckoutSessionDTO, QRPaymentResponseDTO } from '../../../checkout/checkoutApi.js';

export interface PhoneFirstCheckoutQrStepViewProps {
  readonly activeQrPayment: QRPaymentResponseDTO;
  readonly sessionIdFromUrl: string;
  readonly checkoutSession: CheckoutSessionDTO | null;
  readonly onCancel: () => void;
  readonly onContinue: () => void;
}

/**
 * Explicit start-qr allow → pass true. Otherwise omit so QrPaymentView try-loads
 * until poll. Never pass false for a reusable paymentId (stale-hide DTO).
 */
function qrVisiblePropFromStartQrDto(
  qr: Pick<QRPaymentResponseDTO, 'qrVisible' | 'qrAccess'>,
): true | undefined {
  if (qr.qrVisible === true || qr.qrAccess === 'allowed') {
    return true;
  }
  return undefined;
}

export function PhoneFirstCheckoutQrStepView(props: PhoneFirstCheckoutQrStepViewProps): JSX.Element {
  const { activeQrPayment, sessionIdFromUrl, checkoutSession, onCancel, onContinue } = props;

  return (
    <QrPaymentView
      paymentId={activeQrPayment.paymentId}
      checkoutSessionId={sessionIdFromUrl}
      qrCodePayload={activeQrPayment.qrCodePayload ?? null}
      qrVisible={qrVisiblePropFromStartQrDto(activeQrPayment)}
      amountMinor={activeQrPayment.amountMinor}
      currency={activeQrPayment.currency}
      cartClearKioskId={checkoutSession?.kioskId ?? null}
      transactionId={checkoutSession?.transactionId ?? null}
      onCancel={onCancel}
      onContinue={onContinue}
    />
  );
}
